import content from "@/content";
import { scrollToSection } from "./Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-linen border-t border-linen/10 py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <button
          data-testid="footer-brand-btn"
          onClick={() => scrollToSection("#hero")}
          className="font-serif text-2xl tracking-[0.15em] uppercase hover:text-goldsoft transition-colors duration-300"
        >
          {content.brand.name}
        </button>
        <div className="text-center md:text-right">
          <p className="text-[10px] uppercase tracking-[0.25em] text-linen/40">{content.footer.copyright}</p>
          <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-goldsoft/60">India | Worldwide</p>
        </div>
      </div>
    </footer>
  );
}
